document.addEventListener('DOMContentLoaded', function() {
    // Target both metabox labels and sub-field labels in WP-Admin
    document.querySelectorAll('.acf-label label, .acf-table label').forEach(function(label) {
        if (label.innerHTML.includes('[dashicon:')) {
            label.innerHTML = label.innerHTML.replace(
                /\[dashicon:([a-z0-9-]+)\]/g, 
                '<span class="dashicons dashicons-$1" style="vertical-align:middle; margin-right:4px;"></span>'
            );
        }
    });
});